/*eslint-disable */
<style lang="scss">
@import '@/styles/diagram.scss';
</style>

<template>
  <el-container id="draw-flow-container">
    <div class="divide-y diagram-sidebar">
      <div class="" style="padding: 8px">
        <button class="btn primary small" @click="onSaveDiagram">Lưu</button>
      </div>
      <div class="node-templates divide-y">
        <div class="node-templates-group">
          <div class="node-templates-group__header">Hành động</div>
          <ul class="node-templates-group__list divide-y">
            <li
              v-for="n in notificationFunctionNodeTemplates"
              :key="n.id"
              :draggable="n.nodeId === null ? true : false"
              :data-node="n.item"
              :data-id="n.id"
              :data-description="n.description"
              class="drag-drawflow"
              @dragstart="drag($event)"
            >
              <div
                class="node-template"
                :class="n.nodeId === null ? '' : 'active'"
              >
                {{ n.label }}
              </div>
            </li>
          </ul>
        </div>
        <div class="node-templates-group">
          <div class="node-templates-group__header">Nhóm người dùng</div>
          <ul class="node-templates-group__list divide-y">
            <li
              v-for="n in userGroupNodeTemplates"
              :key="n.id"
              :draggable="n.nodeId === null ? true : false"
              :data-id="n.id"
              :data-node="n.item"
              :data-description="n.description"
              class="drag-drawflow"
              @dragstart="drag($event)"
            >
              <div
                class="node-template"
                :class="n.nodeId === null ? '' : 'active'"
              >
                {{ n.label }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-main>
      <div
        id="drawflow"
        @drop="drop($event)"
        @dragover="allowDrop($event)"
      ></div>
    </el-main>
  </el-container>
</template>

<script>
/*eslint-disable */
import {
  getDiagram,
  getFunctions,
  updateDiagram
} from '@/api/config-service/user-group-notification'
import { getUserGroupApi } from '@/api/userConfig/userGroup'
import Drawflow from '@/vendor/DrawFlow'
/* eslint-disable no-unused-import */
import styleDrawflow from 'drawflow/dist/drawflow.min.css'
import Vue from 'vue'
import NotificationFunctionNode from './components/NotificationFunctionNode.vue'
import UserGroupNode from './components/UserGroupNode.vue'
export default {
  name: 'DrawFlowPage',
  components: {
    NotificationFunctionNode,
    UserGroupNode
  },
  data() {
    return {
      isDraggle: false,
      nodeTemplates: [],
      exportValue: null,
      userGroups: [],
      notificationFunctions: [],
      relationship: []
    }
  },
  computed: {
    notificationFunctionNodeTemplates() {
      return this.nodeTemplates.filter(
        node => node.type === 'NotificationFunctionNode'
      )
    },
    userGroupNodeTemplates() {
      return this.nodeTemplates.filter(node => node.type === 'UserGroupNode')
    }
  },
  beforeCreate() {
    styleDrawflow
  },
  async mounted() {
    await this.getDiagramData()
    const id = document.getElementById('drawflow')
    Vue.prototype.$df = new Drawflow(id, Vue, this)
    this.$df.on('nodeSelected', id => {
      const node = this.$df.getNodeFromId(id)
      Object.values(node.outputs).forEach(output => {
        output.connections.forEach(connection => {
          const connectedNode = this.$df.getNodeFromId(connection.node)
          var t = document
            .querySelector(`.drawflow-node[id='node-${connectedNode.id}']`)
            .classList.add('source-selected')
        })
      })

      Object.values(node.inputs).forEach(output => {
        output.connections.forEach(connection => {
          const connectedNode = this.$df.getNodeFromId(connection.node)
          var t = document
            .querySelector(`.drawflow-node[id='node-${connectedNode.id}']`)
            .classList.add('source-selected')
        })
      })
    })

    this.$df.on('nodeUnselected', id => {
      document
        .querySelectorAll('.drawflow-node.source-selected')
        .forEach(el => el.classList.remove('source-selected'))
    })
    this.$df.on('nodeRemoved', removedNode => {
      const removedNodeTemplate = this.nodeTemplates.find(
        ele => ele.nodeId == removedNode.id
      )
      removedNodeTemplate.nodeId = null
    })
    this.$df.registerNode('UserGroupNode', UserGroupNode, {}, {})
    this.$df.registerNode(
      'NotificationFunctionNode',
      NotificationFunctionNode,
      {},
      {}
    )
    this.$df.start()
    this.userGroups.forEach(item => {
      if (!item.hasOwnProperty('x') || !item.hasOwnProperty('y')) {
        return
      }
      this.addNodeToDrawFlow(
        { id: item.id, node: 'UserGroupNode' },
        item.x,
        item.y,
        true
      )
    })

    this.notificationFunctions.forEach(item => {
      if (!item.hasOwnProperty('x') || !item.hasOwnProperty('y')) {
        return
      }
      this.addNodeToDrawFlow(
        { id: item.id, node: 'NotificationFunctionNode' },
        item.x,
        item.y,
        true
      )
    })

    // Wait for css to load before adding connection
    // TODO: Find better way
    setTimeout(() => {
      if (this.relationship != null) {
        this.relationship.forEach(relation => {
          const functionNode = this.nodeTemplates.find(
            ele =>
              ele.id == relation.function_id &&
              ele.type == 'NotificationFunctionNode'
          )
          const userGroupNode = this.nodeTemplates.find(
            ele =>
              ele.id == relation.user_group_id && ele.type == 'UserGroupNode'
          )
          this.$df.addConnection(
            functionNode.nodeId,
            userGroupNode.nodeId,
            'output_1',
            'input_1'
          )
        })
      }
    }, 200)
  },
  methods: {
    async onSaveDiagram() {
      const diagram = this.$df.export()
      const data = diagram.drawflow.Home.data
      const payload = {
        functions: [],
        assigns: [],
        user_groups: []
      }

      Object.values(data).forEach(node => {
        if (node.class == 'NotificationFunctionNode') {
          payload.functions.push({
            id: node.data.id,
            x: node.pos_x,
            y: node.pos_y
          })
          const output = Object.values(node.outputs)[0]
          if (output.connections.length > 0) {
            output.connections.forEach(connection => {
              const connectedNode = data[connection.node]
              payload.assigns.push({
                functionId: node.data.id,
                userGroupId: connectedNode.data.id
              })
            })
          }
        } else if (node.class == 'UserGroupNode') {
          payload.user_groups.push({
            id: node.data.id,
            x: node.pos_x,
            y: node.pos_y
          })
        }
      })

      await updateDiagram(payload)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Đã cập nhật thành công'
          })
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: 'Đã có lỗi xảy ra'
          })
        })
    },
    async getUserGroups() {
      await getUserGroupApi().then(res => {
        this.userGroups = res.data
        this.userGroups.forEach((item, index) =>
          this.nodeTemplates.push({
            id: item.id,
            label: item.name,
            description: item.desc,
            item: 'UserGroupNode',
            input: 1,
            output: 0,
            type: 'UserGroupNode',
            nodeId: null
          })
        )
      })
    },
    async getNotificationFunctions() {
      await getFunctions().then(res => {
        this.notificationFunctions = res.data.map(item => {
          delete item.x
          delete item.y
          return item
        })
        this.notificationFunctions.forEach((item, index) =>
          this.nodeTemplates.push({
            id: item.id,
            label: item.name,
            item: 'NotificationFunctionNode',
            input: 0,
            output: 1,
            type: 'NotificationFunctionNode',
            nodeId: null
          })
        )
      })
    },
    async getDiagramData() {
      await this.getUserGroups()
      await this.getNotificationFunctions()
      await getDiagram().then(res => {
        const userGroups = res.data.user_groups
        const notificationFunctions = res.data.functions
        this.relationship = res.data.relationship

        userGroups.forEach(node => {
          const group = this.userGroups.find(group => node.id == group.id)
          group.x = node.x
          group.y = node.y
        })

        notificationFunctions.forEach(node => {
          const group = this.notificationFunctions.find(
            group => node.id == group.id
          )
          group.x = node.x
          group.y = node.y
        })
      })
    },

    allowDrop: ev => {
      ev.preventDefault()
    },
    drag(ev) {
      if (ev.type === 'touchstart') {
        mobile_item_select = ev.target
          .closest('.drag-drawflow')
          .getAttribute('data-node')
        mobile_item_select = ev.target
          .closest('.drag-drawflow')
          .getAttribute('data-id')
      } else {
        ev.dataTransfer.setData('node', ev.target.getAttribute('data-node'))
        ev.dataTransfer.setData('id', ev.target.getAttribute('data-id'))
      }
    },
    drop(ev) {
      if (ev.type === 'touchend') {
        var parentdrawflow = document
          .elementFromPoint(
            mobile_last_move.touches[0].clientX,
            mobile_last_move.touches[0].clientY
          )
          .closest('#drawflow')
        if (parentdrawflow != null) {
          this.addNodeToDrawFlow(
            mobile_item_select,
            mobile_last_move.touches[0].clientX,
            mobile_last_move.touches[0].clientY
          )
        }
        mobile_item_select = ''
      } else {
        ev.preventDefault()
        var id = ev.dataTransfer.getData('id')
        var node = ev.dataTransfer.getData('node')
        this.addNodeToDrawFlow(
          {
            id,
            node
          },
          ev.clientX,
          ev.clientY
        )
      }
    },
    addNodeToDrawFlow({ id, node }, pos_x, pos_y, initial = false) {
      if (!initial) {
        pos_x =
          pos_x *
            (this.$df.precanvas.clientWidth /
              (this.$df.precanvas.clientWidth * this.$df.zoom)) -
          this.$df.precanvas.getBoundingClientRect().x *
            (this.$df.precanvas.clientWidth /
              (this.$df.precanvas.clientWidth * this.$df.zoom))
        pos_y =
          pos_y *
            (this.$df.precanvas.clientHeight /
              (this.$df.precanvas.clientHeight * this.$df.zoom)) -
          this.$df.precanvas.getBoundingClientRect().y *
            (this.$df.precanvas.clientHeight /
              (this.$df.precanvas.clientHeight * this.$df.zoom))
      }
      const nodeSelected = this.nodeTemplates.find(
        ele => ele.id == id && ele.type == node
      )
      const addedNode = this.$df.addNode(
        node,
        nodeSelected.input,
        nodeSelected.output,
        pos_x,
        pos_y,
        node,
        {
          id: nodeSelected.id,
          name: nodeSelected.label,
          description: nodeSelected.description
        },
        node,
        'vue'
      )
      nodeSelected.nodeId = addedNode
    }
  }
}
</script>
